<template>
  <table class="table table-striped my-4">
    <thead class="thead-dark">
      <tr>
        <th>{{ $t('views.occupancyReport.timeSlot') }}</th>
        <th>{{ $t('views.occupancyReport.absolute.' + reportType) }}</th>
        <th>{{ $t('views.occupancyReport.capacity') }}</th>
        <th>{{ $t('views.occupancyReport.percentage.' + reportType) }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(reportItem, index) in reportItems" :key="index">
        <td>{{ formatDay(reportItem) }} <br class="d-lg-none"> {{ formatTime(reportItem) }}</td>
        <td>{{ reportItem.count }}</td>
        <td>{{ reportItem.capacity }}</td>
        <td>{{ formatPercentage(reportItem) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { TicketReportItem } from '@/generated/openapi';
import { formatTicketTimeDay, formatTicketTimeOnly } from '@/utils/formatUtils';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'ResultListOccupancy',
  props: {
    reportItems: {
      type: Array as PropType<TicketReportItem[]>,
      required: true
    },
    reportType: {
      type: String as PropType<"BOOKED"|"CANCELLED">,
      required: true
    }
  },
  data() {
    return {

    }
  },
  methods: {
    formatTime(reportItem: TicketReportItem) {
      return formatTicketTimeOnly(reportItem);
    },
    formatDay(reportItem: TicketReportItem) {
      return formatTicketTimeDay(reportItem);
    },
    formatPercentage(reportItem: TicketReportItem): string {
      if (!reportItem.capacity || reportItem.capacity < 1) {
        return ''
      }
      return `${Math.round((reportItem.count || 0) / reportItem.capacity * 100)} %`
    }
  }
});
</script>
